

































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import CheckBox from "@/components/CheckBox.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import CarsDTO from "../models/CarsDTO";
import { t } from "@/plugins/i18n";

interface Data {
  items: CarsDTO[];
  selectedItems: CarsDTO[];
}

interface Props {
  title: string;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
}

interface Methods {
  selected(item: CarsDTO): void;
  addToSummary(dataItem: CarsDTO): void;
  newCarChanged(item: CarsDTO): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ApiSearchPage, CheckBox },

  props: {
    title: {
      type: String,
      default: t("BankExtract_GepjarmuKereso"),
    },
  },

  data: () => ({
    items: [],
    selectedItems: [],
  }),

  methods: {
    newCarChanged(item: CarsDTO) {
      item.isNewCar = !item.isNewCar;
    },

    selected(item: CarsDTO) {
      this.$emit("selected", item);
    },

    addToSummary(dataItem: CarsDTO) {
      this.selected(dataItem);
    },
  },

  computed: {
    columns: function() {
      return [
            { field: "brand", title: t("Gyartmany") },
            { field: "model", title: t("Modell") },
            { field: "color", title: t("Szin") },
            { field: "bodyNo", title: t("Alvazszam") },
            { field: "engineNo", title: t("Motorszam") },
            { field: "regNum", title: t("Rendszam") },
            { field: "owner", title: t("Tulajdonos") },
            { field: "ownerRunning", title: t("Uzembentarto") },
            { field: "carStatusName", title: t("BankExtract_GjStatusz"), filterable: false, sortable: false },
            { field: "isNewCar", title: t("BankStatement_UjAuto"), cell: "isNewCar", filterable: false, sortable: false },
            {field: "id", cell: "selectButton", filterable: false, sortable: false}
          ];
    },

    url() {
      return `bank/cars`;
    },
  },
});
